import { createContext } from "react";

export interface ViewportContextProps {
    is2k: boolean;
    is4k: boolean;
    isFhd: boolean;
    width: number;
    height: number;
}

export const ViewportContext = createContext<ViewportContextProps | null>(null);